import { useCurrentUser } from './useCurrentUser'

/**
 * Whether the current user is EnGen staff — a member of EnGen's own Clerk org
 * (employees AND contractors, regardless of role/email). Customer/partner admins
 * and learners are in their own orgs and return false.
 *
 * Reads the backend-authoritative `is_engen_staff` flag from `/users/me`
 * (CurrentUserRead), which is derived from `clerk_engen_organization_id`. This keeps
 * a single source of truth on the backend — no org id duplicated into the frontend.
 * UX-gate only; the backend enforces the same check (`ClerkUser.is_engen_org_member`)
 * on the bug endpoint authoritatively.
 */
export function useIsEngenStaff(): boolean {
  const { user } = useCurrentUser()
  return Boolean(user?.is_engen_staff)
}
